// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_v2-0";
export var checkoutRateBadgeLink = "_v2-1";